import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { Context } from '../MunicipalNoticeBoard';
import { ItemLogo, ItemLogoDiv } from './StyledComponents';

export const CategoryIcon: React.FC<{ itemId?: string; src?: string; style?: React.CSSProperties }> = ({
    itemId,
    src,
    style,
}) => {
    const { icons } = useContext(Context);

    if (itemId) {
        src = icons?.get(itemId)?.url;
    }

    const imgs = src ? (
        <ItemLogo src={src} />
    ) : (
        <ItemLogoDiv>
            <FontAwesomeIcon icon={faCircleInfo} />
        </ItemLogoDiv>
    );

    if (style) {
        return <div style={{ position: 'relative', ...style }}>{imgs}</div>;
    }
    return imgs;
};
